import { render } from "./CollectionPCZ.vue?vue&type=template&id=09efd3b2"
import script from "./CollectionPCZ.vue?vue&type=script&lang=js"
export * from "./CollectionPCZ.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/vhosts/hypergen.be/pcz.hypergen.be/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__